<template>
    <CRow>
        <CCol col="12" class="mb-2 mb-sm-5 video">
            <a class="d-block text-center m-auto position-relative" style="max-width:970px;" href="https://www.aparat.com/v/vbFyO" target="_blank" rel="nofollow">
                <img class="w-100 h-auto" src="https://affili.ir/blog/wp-content/uploads/2020/06/affiliates-tutorials.jpg" alt="اموزش کار با پنل افیلی">
                <span class="show-video">
                    <FaIcon icon="video" color="affili-witch-haze" size="3x" />
                </span>
            </a>
        </CCol>
        <CCol class="py-0 mb-4" col="12" lg="3" md="4" sm="4" v-for="(post, index) in posts" v-bind:key="index">
            <a :href="setUTM(post.href)" target="_blank" class="text-decoration-none">
                <CCard class="h-100">
                    <CCardImg :src="post.image" />
                    <CCardBody>
                        <h4 style="font-size:14px;line-height:1.6">{{ post.title }}</h4>
                    </CCardBody>
                </CCard>
            </a>
        </CCol>
    </CRow>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Affiliates',
    data: function() {
        return {
            posts: [
                {
                    image: 'https://affili.ir/blog/wp-content/uploads/2020/02/blog-banner-4.png',
                    href: 'https://affili.ir/blog/%d8%b4%d8%a8%da%a9%d9%87-%d8%a7%d9%81%db%8c%d9%84%db%8c%d8%aa-%d9%85%d8%a7%d8%b1%da%a9%d8%aa%db%8c%d9%86%da%af-%d8%a7%d9%81%db%8c%d9%84%db%8c-%da%86%db%8c%d8%b3%d8%aa-%d9%88-%da%86%d9%87-%d9%85%db%8c-%da%a9%d9%86%d8%af/',
                    title: 'شبکه افیلیت مارکتینگ افیلی چیست و چه می‌کند؟',
                },
                {
                    image: 'https://affili.ir/blog/wp-content/uploads/2020/03/full-affiliate-marketing-guide.jpg',
                    href: 'https://affili.ir/blog/%d8%b1%d8%a7%d9%87%d9%86%d9%85%d8%a7%db%8c-%d8%ac%d8%a7%d9%85%d8%b9-%d8%a7%d9%81%db%8c%d9%84%db%8c%d8%aa-%d9%85%d8%a7%d8%b1%da%a9%d8%aa%db%8c%d9%86%da%af-%d8%a8%d8%b1%d8%a7%db%8c-%d9%85%d8%a8%d8%aa%d8%af%db%8c%d8%a7%d9%86/',
                    title: 'راهنمای جامع افیلیت مارکتینگ برای مبتدیان',
                },
                {
                    image: 'https://affili.ir/blog/wp-content/uploads/2020/04/affiliate-software-vs-network.jpg',
                    href: 'https://affili.ir/blog/%d9%85%d8%b2%d8%a7%db%8c%d8%a7-%d9%88-%d9%85%d8%b9%d8%a7%db%8c%d8%a8-%d8%b4%d8%a8%da%a9%d9%87-%d8%a7%d9%81%db%8c%d9%84%db%8c%d8%aa-%d9%85%d8%a7%d8%b1%da%a9%d8%aa%db%8c%d9%86%da%af-%d8%af%d8%b1-%d9%85%d9%82%d8%a7%db%8c%d8%b3%d9%87-%d8%a8%d8%a7-%d9%86%d8%b1%d9%85-%d8%a7%d9%81%d8%b2%d8%a7%d8%b1-%d8%a7%d9%81%db%8c%d9%84%db%8c%d8%aa-%d9%85%d8%a7%d8%b1%da%a9%d8%aa%db%8c%d9%86%da%af/',
                    title: 'مقایسه شبکه افیلیت مارکتینگ با نرم‌افزار افیلیت مارکتینگ',
                },
                {
                    image: 'https://affili.ir/blog/wp-content/uploads/2020/03/successful424-840x400.jpg',
                    href: 'https://affili.ir/blog/%db%8c%da%a9-%d8%a7%d9%81%db%8c%d9%84%db%8c%d8%aa-%d9%85%d8%a7%d8%b1%da%a9%d8%aa%d8%b1-%d9%85%d9%88%d9%81%d9%82-%da%86%d9%87-%d9%88%db%8c%da%98%da%af%db%8c-%d9%87%d8%a7%db%8c%db%8c-%d8%af%d8%a7%d8%b1%d8%af-%d9%88-%da%86%da%af%d9%88%d9%86%d9%87-%d8%b9%d9%85%d9%84-%d9%85%db%8c-%da%a9%d9%86%d8%af/',
                    title: 'ویژگی‌های یک افیلیت مارکتر موفق',
                },
                {
                    image: 'https://affili.ir/blog/wp-content/uploads/2019/04/social-1-808x400.jpg',
                    href: 'https://affili.ir/blog/%d8%aa%d8%a7%d8%ab%db%8c%d8%b1-%d8%a7%d8%b3%d8%aa%d9%81%d8%a7%d8%af%d9%87-%d8%a7%d8%b2-%d8%b3%d8%a7%db%8c%d8%aa-%d9%88-%d8%b4%d8%a8%da%a9%d9%87-%d9%87%d8%a7%db%8c-%d8%a7%d8%ac%d8%aa%d9%85%d8%a7%d8%b9%db%8c-%d8%af%d8%b1-%d8%a7%d9%81%db%8c%d9%84%db%8c%d8%aa-%d9%85%d8%a7%d8%b1%da%a9%d8%aa%db%8c%d9%86%da%af/',
                    title: 'تاثیر استفاده از سایت و شبکه‌های اجتماعی در افیلیت مارکتینگ',
                },
            ],
        }
    },
    computed: {
        ...mapGetters('user', [
            'current'
        ])
    },
    methods: {
        setUTM(href) {
            return href+`?utm_source=my.affili&utm_campaign=tutorials&utm_medium=post&utm_content=${this.current.first_name}-${this.current.last_name}`
        }
    }
}
</script>

<style lang="scss">
    .video .show-video {
        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        background: #000;
        margin: auto;
        opacity: 0;
        max-width: 970px;
        transition: all .2s;
    }
    .show-video svg, .show-video span{
        position: absolute;
        top: calc(50% - .5em);
        right: calc(50% - .5em);
        opacity: 1;
    }

    .video:hover .show-video {
        opacity: .8;
    }
</style>